import axios from 'axios'

const systemGet = async () => {
    let response;
    var config = {
        method: 'get',
        url: process.env.REACT_APP_API_URL + '/api/v1/system',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};

const systemUpdate = async (data) => {
    let response;
    var config = {
        method: 'put',
        url: process.env.REACT_APP_API_URL+'/api/v1/system/update',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data : data
    };
    await axios(config)
        .then((res) => {
            response = res;
        })
        .catch((err) => {
            console.log(err);
            response = err
        });
    return response;
};


export {
    systemGet,
    systemUpdate

};